import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Initial time: 10 minutes 48 seconds = 648 seconds
  const [timeLeft, setTimeLeft] = useState(648);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 648); // Reset or stop at 0? Requirement says "resets on page load", usually implies it just runs down. I'll let it loop if it hits 0 for demo purposes or stop. Let's stop at 0.
      // Actually, "resets on page load" means every time the user refreshes, it starts at 10:48.
      // If it hits 0, I'll just keep it at 0 or restart. Let's restart to keep urgency.
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 w-full bg-[#DC2626] text-white z-50 py-2 px-4 shadow-md" data-id="element-14">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base font-medium" data-id="element-15">
        <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-16" />
        <span data-id="element-17">Esta oferta termina pronto:</span>
        <span className="font-bold font-mono bg-red-800 px-2 py-0.5 rounded" data-id="element-18">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}